import React, { StatelessComponent, ReactNode, MouseEvent } from 'react';
import styled from 'styled-components';
import { TransparentButton, Text } from 'mdlkit';

const ButtonStyle = styled(TransparentButton)`
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes[1]}px;

  display: flex;
  flex-direction: column;
  align-items: center;

  color: ${({ theme }) => theme.colors.text};

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    border: 2px solid ${({ theme }) => theme.colors.primary};
  }

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: ${({ theme }) => theme.fontSizes[2]}px;
  }
`;

interface IconButtonProps {
  id: string;
  label: string;
  placeholder: string;
  icon: ReactNode;
  onClick(event: MouseEvent<HTMLButtonElement>): void;
}

const IconButton: StatelessComponent<IconButtonProps> = ({
  id,
  label,
  placeholder,
  icon,
  onClick,
  ...rest
}: IconButtonProps) => {
  return (
    <ButtonStyle id={id} p="sm" onClick={onClick} {...rest}>
      {icon}
      <Text color="primary" bold>
        {label}
      </Text>
      <Text>{placeholder}</Text>
    </ButtonStyle>
  );
};

IconButton.displayName = 'IconButton';

export default IconButton;
